import excelJS from 'exceljs'
import { save } from 'save-file'
import applyDefaultWorkbookView from '/utils/excel-workbook-view'
import moment from 'moment-timezone'
import { getVisibleExportColumns } from '/utils/export-data'

const columns = [
  { name: "User ID", item: "user_id", width: 100 },
  { name: "User Name", item: "username", width: 100 },
  { name: "Enabled", item: "user_enabled", width: 25, format: "yes" },
  { name: "Email", item: "email", width: 100 },
  { name: "Is Admin User", item: "client_admin_enabled", width: 25, format: "yes" },
  { name: "Studio Acesss", item: "studio_enabled", width: 25, format: "yes" },
  { name: "Smartix Scan Acesss", item: "scanner_enabled", width: 25, format: "yes" },
]

const templateListToExcel = async ({ fileName, data, visibleColumns }) => {
  const exportColumns = getVisibleExportColumns(columns, visibleColumns)

  const workbook = new excelJS.Workbook()

  workbook.views = [
    {
      x: 0, y: 0, width: 3, height: 1000,
      firstSheet: 0, activeTab: 1, visibility: 'visible'
    }
  ]

  const font = { name: 'Courier', size: 12, bold: true }

  const dataItem = data
  if (dataItem.length) {

    const passes_worksheet = workbook.addWorksheet("keys")

    exportColumns.map((col, idx) => passes_worksheet.getColumn(idx + 1).width = col.width)

    const passes_row = passes_worksheet.getRow(1)

    exportColumns.map((col, idx) => passes_row.getCell(idx + 1).value = col.name)

    exportColumns.map((col, idx) => passes_row.getCell(idx + 1).font = font)

    dataItem.map((r, i) => {
      const row = passes_worksheet.getRow(i + 2)

      exportColumns.map((col, idx) => row.getCell(idx + 1).value = col.format ? formatDataItem(r, col) : r[col.item])
      exportColumns.map((col, idx) => row.getCell(idx + 1).font = font)
    })
  }

  applyDefaultWorkbookView(workbook)
  const buffer = await workbook.xlsx.writeBuffer()

  await save(buffer, fileName + '.xlsx')
}

export default templateListToExcel

const formatDataItem = (row,col) => {

  const value = row[col.item]

  switch (col.format) {
    case "date" : return moment(value,"YYYYMMDDHHmmSS").format("YYYY-MM-DD HH:mm")
    case "yes" : return value === 1 ? "yes" : ""
  }
}
